import React from 'react'

import arrowLeft from '../assets/images/chevron-left.svg'
import arrowRight from '../assets/images/chevron-right.svg'

const navStyle = {
  position: 'fixed',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '100%',
}

const arrowStyle = {
  height: '50px',
  cursor: 'pointer',
}

function Footer({ handleNextClick, handlePrevClick, prevHidden, nextHidden = false, nextDisabled = false, nextDisabledClick = null, nextHighlighted }) {
  return (
    <div style={navStyle}>
      <div className='relative'>
        <img onClick={handlePrevClick} className={`nav-arrow left prev ${prevHidden ? 'hidden' : ''}`} src={arrowLeft} alt='' />
        <img style={!nextDisabled && nextHighlighted ? { background: '#ff7b00' } : {}} onClick={nextDisabled ? nextDisabledClick : handleNextClick} className={`nav-arrow right next ${nextHidden ? 'hidden' : ''} ${nextDisabled ? 'disabled' : ''}`} src={arrowRight} alt='' />
      </div>
    </div>
  )
}


export default Footer

export function FooterWithPrice({ handleNextClick, handlePrevClick, prevHidden, nextHidden, totalPrice, hidePrice, totalPriceLabel, nextDisabled, disabled, nextHighlighted }) {
  return (
    <>
      <Footer
        handleNextClick={handleNextClick}
        handlePrevClick={handlePrevClick}
        prevHidden={prevHidden || disabled}
        nextHidden={nextHidden || disabled}
        nextDisabled={nextDisabled}
        nextHighlighted={nextHighlighted}
      />
      <div className="footer">
        <div className="navbar" style={{ justifyContent: 'center' }}>
          {hidePrice ? null : 
            <div className="text-center"><b className='footer__total'>{totalPriceLabel}</b> € {totalPrice || 0}</div>
          }
        </div>
      </div>
    </>
  )
}

export function FooterWithClose({ handleCloseClick, isHidden }) {
  return !isHidden ? (
    <Footer
      handlePrevClick={handleCloseClick}
      prevHidden={false}
      nextHidden={true}
    />
  ) : null
}
